import type { Locale } from '@360face/domain';
import { MUSCLES, type MuscleCard, type MuscleId } from './muscles';

const TITLE: Record<Locale, string> = {
  pt: 'Músculos que trabalhamos',
  en: 'Muscles we work',
  fr: 'Muscles travaillés',
  es: 'Músculos que trabajamos',
  ru: 'Какие мышцы работают',
  uk: 'Які м’язи працюють',
  de: 'Muskeln, die wir bearbeiten',
};
const WHAT_TITLE: Record<Locale, string> = {
  pt: 'O que fazemos',
  en: 'What we do',
  fr: 'Ce que nous faisons',
  es: 'Qué hacemos',
  ru: 'Что делаем',
  uk: 'Що робимо',
  de: 'Was wir machen',
};
const LYMPH_TITLE: Record<Locale, string> = {
  pt: 'Como drenamos',
  en: 'How we drain',
  fr: 'Sens du drainage',
  es: 'Cómo drenamos',
  ru: 'Как идёт дренаж',
  uk: 'Як іде дренаж',
  de: 'So drainieren wir',
};

const LYMPH_ITEMS: Record<Locale, [string, string]> = {
  pt: ['Abdómen → pernas → ancas', 'Gânglios linfáticos: virilha, axilas, pescoço'],
  en: ['Abdomen → legs → hips', 'Lymph nodes: groin, armpits, neck'],
  fr: ['Ventre → jambes → hanches', 'Ganglions : aine, aisselles, cou'],
  es: ['Abdomen → piernas → caderas', 'Ganglios: ingle, axilas, cuello'],
  ru: ['Живот → ноги → бёдра', 'Лимфоузлы: пах, подмышки, шея'],
  uk: ['Живіт → ноги → стегна', 'Лімфовузли: пах, пахви, шия'],
  de: ['Bauch → Beine → Hüften', 'Lymphknoten: Leiste, Achseln, Hals'],
};

export function MuscleMap({ card, locale }: { card: MuscleCard; locale: Locale }) {
  const lead = card.lead[locale] ?? card.lead.en;
  const set = card.muscles ?? {};
  const ids = (Object.keys(set) as MuscleId[]).sort((a, b) => (set[b] ?? 0) - (set[a] ?? 0));
  return (
    <section className="v3-muscles">
      <h3>{WHAT_TITLE[locale]}</h3>
      <p>{lead}</p>
      {card.body === 'lymph' && (
        <>
          <h3>{LYMPH_TITLE[locale]}</h3>
          <ul className="v3-muscles-list">
            {LYMPH_ITEMS[locale].map((t) => (
              <li key={t} className="main">
                {t}
              </li>
            ))}
          </ul>
        </>
      )}
      {ids.length > 0 && (
        <>
          <h3>{TITLE[locale]}</h3>
          <ul className="v3-muscles-list">
            {ids.map((k) => (
              <li key={k} className={set[k] === 1 ? 'main' : 'light'}>
                <b>{MUSCLES[k].en}</b> · {MUSCLES[k].pt}
                {card.notes?.[k] && <em> — {card.notes[k][locale] ?? card.notes[k].en}</em>}
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
